<template>
  <div class="lisaui:flex lisaui:flex-col lisaui:gap-2">
    <!-- Parent Node -->
    <InputRow
      :model-value="technicalPlace.parentId"
      name="parentNode"
      :small="true"
      :display-name="t('modules.organization.components.CCTPComponent.parent')"
      :required="!(technicalPlace.id != null && technicalPlace.path.split('.').length === 1)"
    >
      <template #default="{ field: inputField }">
        <InputText
          v-if="props.siteId == null"
          :disabled="true"
          class="w-100"
          :placeholder="t('modules.organization.components.CCTPComponent.sitePlaceholder')"
        />
        <TechnicalPlaceSelect
          v-else
          v-bind="inputField"
          v-model="technicalPlace.parentId"
          id-column="path"
          id-type="string"
          :clearable="false"
          :disabled="technicalPlace.id != null && technicalPlace.path.split('.').length === 1"
          :disabled-nodes="
            technicalPlace.id != null
              ? [{ key: technicalPlace.id.toString(), includeChildren: true }]
              : []
          "
          :variables="variablesForTPSelect"
          :show-inline-create="false"
          class="w-100"
        />
      </template>
    </InputRow>
    <InputRow
      v-model="technicalPlace.costCenterId"
      name="costCenterIdentifier"
      :small="true"
      :display-name="t('modules.organization.components.CCTPComponent.costCenterLabel')"
      required
    >
      <template #default="{ field: inputField }">
        <InputText
          v-if="props.siteId == null"
          :disabled="true"
          class="w-100"
          :placeholder="t('modules.organization.components.CCTPComponent.sitePlaceholder')"
        />
        <CostCenterSelect
          v-else
          v-bind="inputField"
          v-model="technicalPlace.costCenterId"
          :clearable="false"
          :disabled="technicalPlace.id != null && technicalPlace.path.split('.').length === 1"
          :variables="variablesForTPSelect"
        />
      </template>
    </InputRow>

    <InputRow
      v-model="technicalPlace.code"
      name="label"
      :small="true"
      type="text"
      :display-name="t('modules.organization.components.CCTPComponent.codeLabel')"
      required
      :rules="[ltreeSegment(), matches(/^[a-zA-Z0-9]+$/)]"
    />

    <InputRow
      v-model="technicalPlace.name"
      name="name"
      :small="true"
      type="text"
      :display-name="t('modules.organization.components.CCTPComponent.name')"
      required
      :rules="[minLength(1)]"
    />

    <InputRow
      v-model="technicalPlace.description"
      name="description"
      :small="true"
      :display-name="t('modules.organization.components.CCTPComponent.description')"
      type="textarea"
    >
      <template #default="{ field: inputField }">
        <PrimeVueTextarea
          v-bind="inputField"
          v-model="technicalPlace.description"
          type="text"
          rows="3"
          data-max="5"
          name="description"
          class="w-100"
        />
      </template>
    </InputRow>
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { ltreeSegment, matches, minLength } from "@/modules/formValidation";
import { computed } from "vue";
import PrimeVueTextarea from "primevue/textarea";
import InputRow from "@/components/shared/form/InputRow.vue";
import type { TechnicalPlaceEditType } from "../helper/CR_TP_Type";
import TechnicalPlaceSelect from "./selects/TechnicalPlaceSelect.vue";
import InputText from "primevue/inputtext";
import CostCenterSelect from "./selects/CostCenterSelect.vue";

const props = defineProps({
  technicalPlace: {
    type: Object as () => TechnicalPlaceEditType,
    required: true,
  },
  siteId: {
    type: Number,
    required: false,
    default: undefined,
  },
});
const variablesForTPSelect = computed(() => {
  return {
    siteIds: [props.siteId!],
  };
});

const { t } = useTranslation();
</script>
